import { type TOKEN_PAYLOAD } from "@sinch/bus";
import { atom, useAtom } from "jotai";

const tokenAtom = atom<TOKEN_PAYLOAD>(null);

export const useToken = () => useAtom(tokenAtom);
